// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3umnW","inputWrap":"Table_inputWrap__3gfBh","col":"Table_col__2ddMM","bmiTooltip":"Table_bmiTooltip__13yMV"};